import { Children, type ComponentProps, isValidElement } from 'react';
import { cn } from '@/lib/utils';
import { olGutterDigits } from './markdown-list';

export const listClass = 'marker:text-muted-foreground my-3 [&>li+li]:mt-1.5';

/** An ordered answer list whose gutter grows with the widest marker it prints (markdown-list.css). */
export function OrderedList({
  className,
  style,
  children,
  node: _node,
  ...props
}: ComponentProps<'ol'> & { node?: unknown }) {
  const items = Children.toArray(children).filter(isValidElement).length;
  const digits = olGutterDigits(typeof props.start === 'number' ? props.start : undefined, items);
  return (
    <ol
      className={cn('aui-md-ol list-decimal', listClass, className)}
      style={{ ...style, ['--aui-ol-digits' as string]: digits }}
      {...props}
    >
      {children}
    </ol>
  );
}
